/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ series: NonNullable<unknown>, number: NonNullable<unknown>, date: NonNullable<unknown> }} Einvoice_Manual_Issued_CardInputs */

const vi_einvoice_manual_issued_card = /** @type {(inputs: Einvoice_Manual_Issued_CardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã xuất trên MISA: ${i?.series} · ${i?.number} · ${i?.date}`)
};

/**

* @param {Einvoice_Manual_Issued_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_issued_card = /** @type {((inputs: Einvoice_Manual_Issued_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_Issued_CardInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_issued_card(inputs)
});